import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { styleVariables } from '@lib/common';
import { AssignmentDisplayStatusV2 } from '@module/assignment';
import styled, { getSize } from '@xstyled/styled-components';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var getColorByAssignmentType = function getColorByAssignmentType(statusType) {
  switch (statusType) {
    case AssignmentDisplayStatusV2.onGoing.value:
      return "color: ".concat(styleVariables.colors.blue3, "; background: ").concat(styleVariables.colors.blue1, "; border: 1px solid ").concat(styleVariables.colors.blue3, ";");

    case AssignmentDisplayStatusV2.grading.value:
    case AssignmentDisplayStatusV2.upComing.value:
      return "color: ".concat(styleVariables.colors.gold1, "; background: ").concat(styleVariables.colors.red5, ";border: 1px solid ").concat(styleVariables.colors.gold1, ";");

    case AssignmentDisplayStatusV2.completed.value:
      return "color: ".concat(styleVariables.colors.colorSuccessBase, "; background: ").concat(styleVariables.colors.colorSuccessBg, "; border: 1px solid ").concat(styleVariables.colors.colorSuccessBase, ";");

    default:
      return "color: ".concat(styleVariables.colors.gray10, "; background: ").concat(styleVariables.colors.gray3, "; border: 1px solid ").concat(styleVariables.colors.gray10, ";");
  }
};
var StyledAssignmentStatusComponent = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1px 8px;\n  ", ";\n  width: fit-content;\n  border-radius: ", ";\n  display: block;\n  text-align: center;\n  font-size: ", ";\n"])), function (_ref) {
  var statusType = _ref.statusType;
  return getColorByAssignmentType(statusType);
}, getSize('radiusSm'), getSize('typo12'));
export var getTranslatedStatusName = function getTranslatedStatusName(statusId, translation) {
  switch (statusId) {
    case AssignmentDisplayStatusV2.upComing.value:
      return translation.statusUpComing;

    case AssignmentDisplayStatusV2.onGoing.value:
      return translation.statusOnGoing;

    case AssignmentDisplayStatusV2.completed.value:
      return translation.statusEnded;

    case AssignmentDisplayStatusV2.completed.value:
      return translation.statusPublishedScore;

    case AssignmentDisplayStatusV2.grading.value:
      return translation.statusGrading;

    default:
      return translation.statusUpComing;
  }
};
export var AssignmentStatusComponent = function AssignmentStatusComponent(_ref2) {
  var statusType = _ref2.statusType,
      text = _ref2.text,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100px' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '22px' : _ref2$height,
      style = _ref2.style,
      className = _ref2.className;
  return /*#__PURE__*/_jsx(StyledAssignmentStatusComponent, {
    statusType: statusType,
    width: width,
    height: height,
    style: style,
    className: className,
    children: text
  });
};